module.exports = __webpack_public_path__ + "img/chipping5.758cd257.png";